const isReleaseError = (error: Error) => {
  return (
    error.message?.includes('Failed to load script') ||
    error.message?.includes("Failed to execute 'removeChild'") ||
    error.message?.includes('ChunkLoadError') ||
    error.message?.includes('Loading chunk') ||
    error.message?.includes(`Unexpected token '<'`) ||
    error.message?.includes('AggregateError: No error message') ||
    error.message?.includes('ERR_INVALID_STATE') ||
    error.message?.includes('Unable to enqueue') ||
    error.message?.includes('Invalid state')
  )
}

export default isReleaseError
